import { BankOutlined } from '@ant-design/icons';
import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '@framework/engine/schema/expressions/references/builder/getSimpleWidgetReference.ts';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { CommonComputedWidgetPreview } from '@framework/engine/schema/widgets/repository/computed/CommonComputedWidgetPreview.tsx';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { BurdenWidgetComponent } from './BurdenWidgetComponent.tsx';
import { BurdenWidgetConfigComponent } from './BurdenWidgetConfigComponent.tsx';
import { BurdenWidgetConfigSchema } from './BurdenWidgetConfigSchema.tsx';
import { createBurdenWidgetFormSchema } from './createBurdenWidgetFormSchema.ts';
import { type IBurdenWidget, WidgetTypeBurden } from './IBurdenWidget.ts';

declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    Burden = 'burden',
  }
}

/**
 * Widget per la gestione del calcolo dell'onere
 */
export const BurdenWidgetType: IWidgetType<IBurdenWidget> = {
  type: WidgetTypeBurden,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  name: 'Onere',
  icon: <BankOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Number),
  getSiblingReferences: () => [],
  formComponent: BurdenWidgetComponent,
  createFormSchema: createBurdenWidgetFormSchema,
  previewComponent: CommonComputedWidgetPreview,
  configValidator: BurdenWidgetConfigSchema,
  configComponent: BurdenWidgetConfigComponent,
  configOptions: {},
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  rules: [],
  alwaysEnabled: true,
};
